import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(function Card(
  { className, style, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('rounded-xl border bg-surface shadow-sm', className)}
      style={{ borderColor: 'var(--color-border-tertiary)', ...style }}
      {...rest}
    />
  );
});

// Default padding comes from the density tokens (.card-body/.card-header in
// index.css) so the /me Comfortable↔Compact toggle actually changes the UI.
// Explicit p-* utilities passed via className still override.
export function CardBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('card-body', className)} {...rest} />;
}

export function CardHeader({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('card-header', className)} {...rest} />;
}

export function CardTitle({ className, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('text-base font-semibold text-ink', className)} {...rest} />;
}
